export default __webpack_public_path__ + "static/media/alternateProfile.21df1b1e.svg";